// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vuex from 'vuex'
import Vue from 'vue'
import App from './App'
import router from './router'

import $ from 'jquery'
window.jQuery = $

// 导入组件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 自定义组件
import './assets/css/elementui-vue.css'

// 导入全局样式表
import './assets/css/global.css'
import 'bootstrap/dist/css/bootstrap.css'

// 导入图标
import './assets/fonts/iconfont.css'
import 'font-awesome/css/font-awesome.min.css'

// 引入echarts
import echarts from 'echarts'
import 'echarts/map/js/china'
Vue.prototype.$echarts = echarts
import china from 'echarts/map/json/china.json'
echarts.registerMap('china', china)

//复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

// // 配置axios请求
import axios from 'axios'
window.isReresh = false;//用于判断是否刷新，不能少
Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.use(ElementUI)
// Vue.use(Vuex);
// export default new Vuex.Store({
//   state: {
//       user: {},
//       token: null,
//       title: ''
//   },
//   mutations: {
//       // 登录成功将, token保存在localStorage中
//       [types.LOGIN]: (state, data) => {
//           localStorage.token = data;
//           state.token = data;
//       },
//       // 退出登录将, token清空
//       [types.LOGOUT]: (state) => {
//           localStorage.removeItem('token');
//           state.token = null
//       }
//   }
// });
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js